export const certificateMessages = {
  CERTIFICATE_INPUT_INVALID: '입력값과 승인 근거를 확인해 주세요. 사유는 500자 이내로 입력해 주세요.',
  CERTIFICATE_NOT_FOUND: '수료증 또는 템플릿을 찾을 수 없습니다. 목록을 다시 확인해 주세요.',
  CERTIFICATE_SCOPE_DENIED: '본인의 수료증만 조회할 수 있습니다. 로그인 상태를 확인해 주세요.',
  CERTIFICATE_CONFIRMED_REQUIRED: '취소되지 않은 수강의 최신 수료 확정 후 발급할 수 있습니다.',
  CERTIFICATE_TEMPLATE_REQUIRED: '확정된 수료증 템플릿(공통 또는 과정 구분)이 없습니다. 관리자 수료증 템플릿에서 확정해 주세요.',
  CERTIFICATE_TEMPLATE_IMMUTABLE: '확정 문구는 변경할 수 없습니다. 새 템플릿 초안을 작성해 주세요.',
  CERTIFICATE_TEMPLATE_STATE_CONFLICT: '템플릿 상태가 변경되었습니다. 최신 정보를 다시 확인해 주세요.',
  CERTIFICATE_TEMPLATE_VERSION_CONFLICT: '템플릿이 먼저 변경되었습니다. 최신 정보를 다시 확인해 주세요.',
  CERTIFICATE_VERSION_CONFLICT: '수료 결과 또는 개설 연결이 변경되었습니다. 최신 상태를 다시 확인해 주세요.',
  CERTIFICATE_PREVIOUS_CHANGED: '이미 재발급했거나 직전 증서가 변경되었습니다. 최신 증서를 확인해 주세요.',
  CERTIFICATE_REQUEST_CONFLICT: '이전 요청과 입력이 다릅니다. 기존 처리 이력을 확인해 주세요.',
  CERTIFICATE_NOT_VALID: '수료 결과가 변경되었거나 새 증서로 대체되어 이 증서는 사용할 수 없습니다.',
  CERTIFICATE_DOCUMENT_UNAVAILABLE: '증서 원문을 읽을 수 없습니다. 교육 운영 담당자에게 문의해 주세요.',
  CERTIFICATE_MEMBER_DATA_UNAVAILABLE: '발급에 필요한 회원 성명을 확인할 수 없습니다. 교육 운영 담당자에게 문의해 주세요.',
}
export const certificateStates = { VALID: '유효', REVOKED: '수료 취소', COMPLETION_CHANGED: '수료 결과 변경', SUPERSEDED: '재발급으로 대체', ENROLLMENT_CANCELLED: '수강 취소', UNVERIFIED: '상태 확인 필요' }
